class CtmCurtBgChange extends HTMLElement {
  connectedCallback() {
    this._tabs = Array.from(this.querySelectorAll('.ctm-curt_bg-change__tab'));
    this._layers = Array.from(this.querySelectorAll('.ctm-curt_bg-change__material-layer'));
    this._status = this.querySelector('.ctm-drapes_sr');
    this._selection = [];
    this._selectionLabels = [];
    this._mediaQuery = window.matchMedia('(max-width: 989px)');
    this._setBackgroundReadyState();
    this._markMissingLayers();

    this._tabs.forEach((tab, tabI) => {
      const buttons = Array.from(tab.querySelectorAll('[data-option-value]'));
      if (!buttons.length) return;

      const activeBtn = buttons.find((btn) => btn.classList.contains('is-active')) || buttons[0];
      this._selection[tabI] = activeBtn?.dataset.optionValue || '';
      this._selectionLabels[tabI] = activeBtn?.dataset.optionLabel || '';

      buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this._selectOption(tabI, btn);
        });

        btn.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            this._focusSiblingOption(buttons, btn, 1);
          }

          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            this._focusSiblingOption(buttons, btn, -1);
          }
        });
      });
    });

    this._mediaQuery.addEventListener('change', () => {
      this._updateMaterialBySelection();
    });

    this._updateMaterialBySelection();
  }

  _setBackgroundReadyState() {
    const bgImage = this.querySelector('.ctm-curt_bg-change__base-bg');
    if (!bgImage || bgImage.tagName !== 'IMG') {
      this.classList.add('is-bg-ready');
      return;
    }

    const markReady = () => {
      this.classList.add('is-bg-ready');
    };

    if (bgImage.complete && bgImage.naturalWidth > 0) {
      markReady();
      return;
    }

    bgImage.addEventListener('load', markReady, { once: true });
    bgImage.addEventListener('error', markReady, { once: true });
  }

  _markMissingLayers() {
    this._layers.forEach((layer) => {
      const img = layer.querySelector('img');
      if (!img) return;

      const setMissing = () => {
        layer.classList.add('is-missing');
        if (layer.classList.contains('is-active')) {
          this._updateMaterialBySelection();
        }
      };

      img.addEventListener('error', setMissing);

      if (img.complete && img.naturalWidth === 0) {
        setMissing();
      }
    });
  }

  _selectOption(tabI, nextBtn) {
    const tab = this._tabs[tabI];
    if (!tab || !nextBtn) return;

    const buttons = Array.from(tab.querySelectorAll('[data-option-value]'));
    buttons.forEach((btn) => {
      const isSelected = btn === nextBtn;
      btn.classList.toggle('is-active', isSelected);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      btn.setAttribute('aria-checked', isSelected ? 'true' : 'false');
    });
    nextBtn.classList.add('is-active');

    this._selection[tabI] = nextBtn.dataset.optionValue || '';
    this._selectionLabels[tabI] = nextBtn.dataset.optionLabel || '';
    this._updateMaterialBySelection();
  }

  _focusSiblingOption(buttons, currentButton, direction) {
    const currentIndex = buttons.indexOf(currentButton);
    if (currentIndex < 0) return;

    const nextIndex = (currentIndex + direction + buttons.length) % buttons.length;
    const nextButton = buttons[nextIndex];
    nextButton.focus();
    this._selectOption(Number(nextButton.dataset.tabIndex), nextButton);
  }

  _updateMaterialBySelection() {
    const comboKey = this._selection.filter(Boolean).join('-');
    if (!comboKey) return;

    const viewport = this._mediaQuery.matches ? 'mobile' : 'desktop';
    const next = this._layers.find((layer) => {
      const layerCombo = layer.dataset.comboKey || '';
      const layerViewport = layer.dataset.viewport || 'desktop';
      return layerCombo === comboKey && layerViewport === viewport && !layer.classList.contains('is-missing');
    });

    this._layers.forEach((layer) => layer.classList.remove('is-active'));

    if (next) {
      next.classList.add('is-active');
      this.classList.remove('is-no-result');
      this._announceSelection();
      return;
    }

    this.classList.add('is-no-result');
    this._announceSelection();
  }

  _announceSelection() {
    if (!this._status) return;

    const labels = this._selectionLabels.filter(Boolean);
    if (!labels.length) return;

    this._status.textContent = `Selected ${labels.join(', ')}`;
  }
}

if (!customElements.get('ctm-curt_bg-change')) {
  customElements.define('ctm-curt_bg-change', CtmCurtBgChange);
}
